import { createSelector } from "reselect";

const getSpacesData = (state) => state.spaces.data;
const getSpaceEntities = (state) => state.entities.spaces;

/*****************
 *
 * EXPORT METHODS
 *
 *****************/

export const getSpaces = (state, canReserve = false) =>
    createSelector(getSpacesData, getSpaceEntities, (data, spaces) => {
        return data.map((spaceId) => spaces[spaceId]).filter(space => canReserve ? space.can_reserve : true);
    })(state);

export const getSpaceDetails = (state, id) =>
    createSelector(getSpaceEntities, (spaces) => {
        if (!spaces[id]) return null;

        return spaces[id];
    })(state);
